module.exports = __webpack_public_path__ + "img/Hr_logo_250px-64.0c7410fc.png";